import './article-header.scss';

/**
 * version    1.0
 * class      <type> (article header)
 * classdesc
 */
export class ArticleHeader {}
